// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"03f97634","498":"12698ef4","513":"4cb888a0","885":"2ec7cf9e"}[chunkId] + ".chunk.js";
};